import React, { useEffect, useState } from "react";
import "../../assets/css/createShipmentCSS.css";
import "../../assets/css/toastCSS.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSelector } from "react-redux";
import supabase from "../../../src/supabaseClient";
import { useNavigate } from "react-router-dom";
import { checkJobOrderExists } from "../../utils/jobOrderGenerator";
import axios from "axios";
import { API_BASE_URL } from "../../config/api";

const CreateShipment = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const user = useSelector((state) => state.auth.user);
  const user_id = user.id;
  const created_by = user.user_name;
  const navigate = useNavigate();
  const [submissionSuccess, setSubmissionSuccess] = useState(false);
  const [corporateClients, setCorporateClients] = useState([]);
  const API_URL = API_BASE_URL;

  const [shipperDetails, setShipperDetails] = useState({
    name: "",
    email: "",
    unit: "",
    city: "",
    street: "",
    country: "",
    phone: "",
    building: "",
  });
  const [receiverDetails, setReceiverDetails] = useState({
    name: "",
    email: "",
    unit: "",
    city: "",
    street: "",
    country: "",
    phone: "",
    building: "",
  });
  const [shipmentDetails, setShipmentDetails] = useState({
    description: "",
    type: "",
    shipment_code: "",
    shipment_transport: "",
    instructions: "",
    shipment_mode: "",
    terms: "",
    gross_weight: "",
    eta: "",
    etd: "",
    receivedDate: "",
    remark: "",
    packages: "",
    volume: "",
    containers: [],
    total_weight: "",
    dimensions: [],
    chargeable_weight: "",
    job_order: "",
    commodity: "",
    number_pcs: "",
    cbm: "",
    origin: "",
    destination: "",
    shipment_bound: "",
    flight: "",
    truck_type: "",
    delivery_mode: "",
    corporate_client: "",
    carrier_forwarder: "",
    masterWaybill: "",
    houseWaybill: "",
  });

  const [joError, setJoError] = useState("");

  const handleJobOrderChange = async (e) => {
    const value = e.target.value;
    setShipmentDetails({ ...shipmentDetails, job_order: value });

    if (!value.trim()) {
      setJoError("");
      return;
    }

    try {
      const exists = await checkJobOrderExists(value.trim());
      setJoError(exists ? "This Job Order already exists." : "");
    } catch {
      setJoError("");
    }
  };

  const formatDate = (date) => {
    if (!date) return date;
    const parsedDate = new Date(date);
    return isNaN(parsedDate)
      ? date
      : parsedDate.toLocaleDateString("en-US", {
          year: "numeric",
          month: "long",
          day: "numeric",
        });
  };

  const filterEmptyFields = (data) => {
    return Object.entries(data)
      .filter(
        ([key, value]) => value !== null && value !== undefined && value !== ""
      )
      .map(([key, value]) => [
        key,
        key.toLowerCase().includes("date") ? formatDate(value) : value,
      ]);
  };

  // Fetch corporate clients on component mount
  useEffect(() => {
    const fetchCorporateClients = async () => {
      try {
        const response = await axios.get(
          `${API_URL}/api/departments?type=corporate&status=active`
        );
        const clients = response.data.departments || [];
        setCorporateClients(clients.map((c) => c.name));
      } catch (error) {
        console.error("Error fetching corporate clients:", error);
      }
    };

    fetchCorporateClients();
  }, [API_URL]);

  useEffect(() => {
    // console.log("Shipper Details: ", shipperDetails);
  }, [shipperDetails]);
  useEffect(() => {
    // console.log("Receiver Details: ", receiverDetails);
  }, [receiverDetails]);
  useEffect(() => {
    // console.log("Shipment Details: ", shipmentDetails);
  }, [shipmentDetails]);

  useEffect(() => {
    const generateJobOrder = async () => {
      const { shipment_transport, type } = shipmentDetails;

      if (shipment_transport && type) {
        try {
          const currentMonth = new Date().toISOString().slice(5, 7);
          const currentYear = new Date().toISOString().slice(2, 4);

          let prefix;
          if (shipment_transport === "AIR") {
            prefix = `${type[0]}${shipment_transport[0]}`;
          } else {
            prefix = `${type[0]}${shipment_transport[0]}`;
          }

          const { data: jobOrders, error } = await supabase
            .from("shipments")
            .select("job_order")
            .ilike("job_order", `${prefix}${currentMonth}%${currentYear}`);

          if (error) throw error;

          const existingJobOrders = jobOrders || [];
          const lastNumber =
            existingJobOrders
              .map((order) =>
                parseInt(
                  order.job_order
                    .replace(`${prefix}${currentMonth}`, "")
                    .replace(`${currentYear}`, ""),
                  10
                )
              )
              .filter((num) => !isNaN(num))
              .sort((a, b) => b - a)[0] || 0;

          const increment = String(lastNumber + 1).padStart(2, "0");
          const newJobOrder = `${prefix}${currentMonth}${increment}${currentYear}`;

          setShipmentDetails((prev) => ({ ...prev, job_order: newJobOrder }));
        } catch (err) {
          console.error("Error generating job order:", err);
          toast.error("Error generating job order. Please try again.");
        }
      }
    };

    const generateJobOrderForDomestic = async () => {
      const { shipment_bound, shipment_transport, type } = shipmentDetails;

      if (shipment_bound && shipment_transport && type) {
        try {
          const currentMonth = new Date().toISOString().slice(5, 7);
          const currentYear = new Date().toISOString().slice(2, 4);

          let prefix;
          if (shipment_bound === "OUTBOUND") {
            prefix = `${shipment_bound[0]}${shipment_transport[0]}`;
          } else if (shipment_bound === "INBOUND") {
            prefix = `${shipment_bound[0]}${shipment_transport[0]}`;
          }

          const { data: jobOrders, error } = await supabase
            .from("shipments")
            .select("job_order")
            .ilike("job_order", `${prefix}${currentMonth}%${currentYear}`);

          if (error) throw error;

          const existingJobOrders = jobOrders || [];
          const lastNumber =
            existingJobOrders
              .map((order) =>
                parseInt(
                  order.job_order
                    .replace(`${prefix}${currentMonth}`, "")
                    .replace(`${currentYear}`, ""),
                  10
                )
              )
              .filter((num) => !isNaN(num))
              .sort((a, b) => b - a)[0] || 0;

          const increment = String(lastNumber + 1).padStart(2, "0");
          const newJobOrder = `${prefix}${currentMonth}${increment}${currentYear}`;

          setShipmentDetails((prev) => ({ ...prev, job_order: newJobOrder }));
        } catch (err) {
          console.error("Error generating job order:", err);
          toast.error("Error generating job order. Please try again.");
        }
      }
    };

    const generateJobOrderForAirOrSea = async () => {
      const { shipment_mode, type } = shipmentDetails;

      if (
        (shipment_mode === "IMPORT" ||
          shipment_mode === "EXPORT" ||
          shipment_mode === "IMPORT-EVENT" ||
          shipment_mode === "EXPORT-EVENT") &&
        (type === "AIR" || type === "SEA")
      ) {
        try {
          const currentMonth = new Date().toISOString().slice(5, 7);
          const currentYear = new Date().toISOString().slice(2, 4);

          let prefix;
          if (
            shipment_mode === "IMPORT-EVENT" ||
            shipment_mode === "EXPORT-EVENT"
          ) {
            prefix = "PJ";
          } else if (type === "AIR") {
            prefix = shipment_mode === "EXPORT" ? "AE" : "AI";
          } else if (type === "SEA") {
            prefix = shipment_mode === "EXPORT" ? "SE" : "SI";
          }

          const { data: jobOrders, error } = await supabase
            .from("shipments")
            .select("job_order")
            .ilike("job_order", `${prefix}${currentMonth}%${currentYear}`);

          if (error) throw error;

          const existingJobOrders = jobOrders || [];
          const lastNumber =
            existingJobOrders
              .map((order) =>
                parseInt(
                  order.job_order
                    .replace(`${prefix}${currentMonth}`, "")
                    .replace(`${currentYear}`, ""),
                  10
                )
              )
              .filter((num) => !isNaN(num))
              .sort((a, b) => b - a)[0] || 0;

          const increment = String(lastNumber + 1).padStart(2, "0");
          const newJobOrder = `${prefix}${currentMonth}${increment}${currentYear}`;

          setShipmentDetails((prev) => ({ ...prev, job_order: newJobOrder }));
        } catch (err) {
          console.error("Error generating job order for AIR/SEA:", err);
          toast.error(
            "Error generating job order for AIR/SEA. Please try again."
          );
        }
      }
    };

    const generateJobOrderForLand = async () => {
      const { type } = shipmentDetails;

      if (type === "LAND") {
        try {
          const currentMonth = new Date().toISOString().slice(5, 7);
          const currentYear = new Date().toISOString().slice(2, 4);

          const prefix = "LT";

          const { data: jobOrders, error } = await supabase
            .from("shipments")
            .select("job_order")
            .ilike("job_order", `${prefix}${currentMonth}%${currentYear}`);

          if (error) throw error;

          const existingJobOrders = jobOrders || [];
          const lastNumber =
            existingJobOrders
              .map((order) =>
                parseInt(
                  order.job_order
                    .replace(`${prefix}${currentMonth}`, "")
                    .replace(`${currentYear}`, ""),
                  10
                )
              )
              .filter((num) => !isNaN(num))
              .sort((a, b) => b - a)[0] || 0;

          const increment = String(lastNumber + 1).padStart(2, "0");
          const newJobOrder = `${prefix}${currentMonth}${increment}${currentYear}`;

          setShipmentDetails((prev) => ({ ...prev, job_order: newJobOrder }));
        } catch (err) {
          console.error("Error generating job order for LAND:", err);
          toast.error("Error generating job order for LAND. Please try again.");
        }
      } else {
        console.log("Not a LAND type shipment.");
      }
    };

    if (shipmentDetails.type === "AIR" || shipmentDetails.type === "SEA") {
      generateJobOrderForAirOrSea();
    } else if (shipmentDetails.type === "DOMESTIC") {
      generateJobOrderForDomestic();
    } else if (shipmentDetails.type === "LAND") {
      generateJobOrderForLand();
    } else {
      generateJobOrder();
    }
  }, [
    shipmentDetails.shipment_code,
    shipmentDetails.shipment_transport,
    shipmentDetails.type,
    shipmentDetails.shipment_mode,
  ]);

  const [errors] = useState({
    shipperDetails: {},
    receiverDetails: {},
    shipmentDetails: {},
  });

  const steps = [
    { title: "Shipment Type", description: "Select the type of shipment" },
    {
      title: "Shipper Details",
      description: "Please fill in the shipper's details",
    },
    {
      title: "Consignee Details",
      description: "Please fill in the Consignee's details",
    },
    {
      title: "Shipment Details",
      description: "Please provide the shipment's details",
    },
    { title: "Confirmation", description: "Review and confirm the details" },
  ];

  const handleNext = () => {
    if (currentStep < steps.length - 1) setCurrentStep(currentStep + 1);
  };

  const handleBack = () => {
    if (currentStep > 0) setCurrentStep(currentStep - 1);
  };

  const handleShipmentTypeClick = (type) => {
    setShipmentDetails((prevDetails) => ({ ...prevDetails, type }));
    setCurrentStep(1);
  };

  const handleInputChange = (e, setSection) => {
    const { name, value } = e.target;
    setSection((prev) => ({ ...prev, [name]: value }));
  };

  const addDimension = (e) => {
    e.preventDefault();
    setShipmentDetails({
      ...shipmentDetails,
      dimensions: [...shipmentDetails.dimensions, ""],
    });
  };

  const handleDeleteDimension = (index) => {
    const updatedDimensions = shipmentDetails.dimensions.filter(
      (_, i) => i !== index
    );
    setShipmentDetails({ ...shipmentDetails, dimensions: updatedDimensions });
  };

  const handleDimensionChange = (e, index) => {
    const { value } = e.target;
    const dimensions = shipmentDetails.dimensions;
    dimensions[index] = value;
    setShipmentDetails({ ...shipmentDetails, dimensions });
  };

  const addContainer = (e) => {
    e.preventDefault();
    setShipmentDetails({
      ...shipmentDetails,
      containers: [...shipmentDetails.containers, ""],
    });
  };

  const handleDeleteContainer = (index) => {
    const updatedContainers = shipmentDetails.containers.filter(
      (_, i) => i !== index
    );
    setShipmentDetails({ ...shipmentDetails, containers: updatedContainers });
  };

  const handleContainerChange = (e, index) => {
    const { value } = e.target;
    const containers = shipmentDetails.containers;
    containers[index] = value;
    setShipmentDetails({ ...shipmentDetails, containers });
  };

  const renderFormFields = () => {
    if (currentStep === 0) {
      return (
        <div className="w-full max-w-6xl mx-auto">
          <div className="rounded-3xl shadow-xl border border-white/20 overflow-hidden mb-8">
            {/* Header */}
            <div className="bg-blue px-8 py-6">
              <div className="flex items-center gap-4">
                <div className="p-3 bg-white/20 rounded-2xl">
                  <i className="fas fa-shipping-fast text-white text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-white font-bold text-2xl">
                    Choose Your Shipping Method
                  </h3>
                  <p className="text-white/80">
                    Select the most suitable transport option for your cargo
                  </p>
                </div>
              </div>
            </div>

            {/* Body */}
            <div className="p-8 bg-white/95 backdrop-blur-sm">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
                <div
                  className="group relative overflow-hidden bg-white rounded-2xl shadow-lg border border-gray-100 p-6 cursor-pointer transition-all duration-300 transform hover:scale-105 hover:shadow-xl hover:bg-blue"
                  onClick={() => handleShipmentTypeClick("SEA")}
                >
                  <div className="absolute top-0 right-0 w-20 h-20 bg-blue/5 rounded-full blur-2xl opacity-50 group-hover:bg-white/20"></div>
                  <div className="relative z-10 flex flex-col items-center text-center h-32 justify-center">
                    <div className="p-4 bg-blue/10 rounded-2xl mb-4 group-hover:bg-white/20 transition-all duration-300">
                      <i className="fas fa-ship text-blue text-3xl group-hover:text-white"></i>
                    </div>
                    <span className="text-blue text-lg font-bold group-hover:text-white transition-all duration-300">
                      Sea Freight
                    </span>
                    <span className="text-grey text-sm group-hover:text-white/80 mt-1">
                      Ocean Transport
                    </span>
                  </div>
                </div>

                <div
                  className="group relative overflow-hidden bg-white rounded-2xl shadow-lg border border-gray-100 p-6 cursor-pointer transition-all duration-300 transform hover:scale-105 hover:shadow-xl hover:bg-blue"
                  onClick={() => handleShipmentTypeClick("AIR")}
                >
                  <div className="absolute top-0 right-0 w-20 h-20 bg-blue/5 rounded-full blur-2xl opacity-50 group-hover:bg-white/20"></div>
                  <div className="relative z-10 flex flex-col items-center text-center h-32 justify-center">
                    <div className="p-4 bg-blue/10 rounded-2xl mb-4 group-hover:bg-white/20 transition-all duration-300">
                      <i className="fas fa-plane text-blue text-3xl group-hover:text-white"></i>
                    </div>
                    <span className="text-blue text-lg font-bold group-hover:text-white transition-all duration-300">
                      Air Freight
                    </span>
                    <span className="text-grey text-sm group-hover:text-white/80 mt-1">
                      Express Delivery
                    </span>
                  </div>
                </div>

                <div
                  className="group relative overflow-hidden bg-white rounded-2xl shadow-lg border border-gray-100 p-6 cursor-pointer transition-all duration-300 transform hover:scale-105 hover:shadow-xl hover:bg-blue"
                  onClick={() => handleShipmentTypeClick("BROKERAGE")}
                >
                  <div className="absolute top-0 right-0 w-20 h-20 bg-blue/5 rounded-full blur-2xl opacity-50 group-hover:bg-white/20"></div>
                  <div className="relative z-10 flex flex-col items-center text-center h-32 justify-center">
                    <div className="p-4 bg-blue/10 rounded-2xl mb-4 group-hover:bg-white/20 transition-all duration-300">
                      <i className="fas fa-briefcase text-blue text-3xl group-hover:text-white"></i>
                    </div>
                    <span className="text-blue text-lg font-bold group-hover:text-white transition-all duration-300">
                      Brokerage
                    </span>
                    <span className="text-grey text-sm group-hover:text-white/80 mt-1">
                      Customs Service
                    </span>
                  </div>
                </div>

                <div
                  className="group relative overflow-hidden bg-white rounded-2xl shadow-lg border border-gray-100 p-6 cursor-pointer transition-all duration-300 transform hover:scale-105 hover:shadow-xl hover:bg-blue"
                  onClick={() => handleShipmentTypeClick("DOMESTIC")}
                >
                  <div className="absolute top-0 right-0 w-20 h-20 bg-blue/5 rounded-full blur-2xl opacity-50 group-hover:bg-white/20"></div>
                  <div className="relative z-10 flex flex-col items-center text-center h-32 justify-center">
                    <div className="p-4 bg-blue/10 rounded-2xl mb-4 group-hover:bg-white/20 transition-all duration-300">
                      <i className="fas fa-map text-blue text-3xl group-hover:text-white"></i>
                    </div>
                    <span className="text-blue text-lg font-bold group-hover:text-white transition-all duration-300">
                      Domestic
                    </span>
                    <span className="text-grey text-sm group-hover:text-white/80 mt-1">
                      Local Transport
                    </span>
                  </div>
                </div>

                <div
                  className="group relative overflow-hidden bg-white rounded-2xl shadow-lg border border-gray-100 p-6 cursor-pointer transition-all duration-300 transform hover:scale-105 hover:shadow-xl hover:bg-blue"
                  onClick={() => handleShipmentTypeClick("LAND")}
                >
                  <div className="absolute top-0 right-0 w-20 h-20 bg-blue/5 rounded-full blur-2xl opacity-50 group-hover:bg-white/20"></div>
                  <div className="relative z-10 flex flex-col items-center text-center h-32 justify-center">
                    <div className="p-4 bg-blue/10 rounded-2xl mb-4 group-hover:bg-white/20 transition-all duration-300">
                      <i className="fas fa-truck text-blue text-3xl group-hover:text-white"></i>
                    </div>
                    <span className="text-blue text-lg font-bold group-hover:text-white transition-all duration-300">
                      Land Transport
                    </span>
                    <span className="text-grey text-sm group-hover:text-white/80 mt-1">
                      Road & Rail
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    // BROKERAGE SHIPMENT
    if (currentStep === 3 && shipmentDetails.type === "BROKERAGE") {
      return (
        <div className="w-full max-w-6xl mx-auto">
          <div className="rounded-3xl shadow-xl border border-white/20 overflow-hidden">
            <div className="bg-blue px-8 py-6">
              <div className="flex items-center gap-4">
                <div className="p-3 bg-white/20 rounded-2xl">
                  <i className="fas fa-briefcase text-white text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-white font-bold text-2xl">
                    Brokerage Shipment Details
                  </h3>
                  <p className="text-white/80">
                    Configure your customs brokerage service
                  </p>
                </div>
              </div>
            </div>

            <div className="p-8 bg-white/95 backdrop-blur-sm">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-file-alt text-blue text-xs"></i>
                    Shipment Description
                  </label>
                  <input
                    type="text"
                    name="description"
                    value={shipmentDetails.description}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                    placeholder="Enter shipment description"
                    onChange={(e) => handleInputChange(e, setShipmentDetails)}
                  />
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-tag text-blue text-xs"></i>
                    Shipment Type
                  </label>
                  <input
                    type="text"
                    name="type"
                    value={shipmentDetails.type}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl bg-gray-50 text-grey cursor-not-allowed"
                    disabled
                  />
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-arrow-right text-blue text-xs"></i>
                    Shipment Mode
                  </label>
                  <div className="relative">
                    <input
                      type="text"
                      name="shipment_mode"
                      value="IMPORT"
                      className="w-full p-4 border-2 border-gray-200 rounded-2xl bg-gray-50 text-grey cursor-not-allowed"
                      readOnly
                    />
                  </div>
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-shipping-fast text-blue text-xs"></i>
                    Transport Mode
                  </label>
                  <div className="relative">
                    <select
                      name="shipment_transport"
                      value={shipmentDetails.shipment_transport}
                      onChange={(e) => handleInputChange(e, setShipmentDetails)}
                      className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md appearance-none"
                    >
                      <option value="">Select Transport Mode</option>
                      <option value="AIR">Air Transport</option>
                      <option value="SEA">Sea Transport</option>
                    </select>
                    <div className="absolute inset-y-0 right-0 flex items-center pr-4 pointer-events-none">
                      <i className="fas fa-chevron-down text-blue text-sm"></i>
                    </div>
                  </div>
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-code text-blue text-xs"></i>
                    Job Order Code
                  </label>
                  <input
                    type="text"
                    name="job_order"
                    value={shipmentDetails.job_order}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md font-mono"
                    placeholder="Auto-generated code"
                    onChange={handleJobOrderChange}
                  />
                  {joError && (
                    <p className="text-red-500 text-xs mt-1">{joError}</p>
                  )}
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-building text-blue text-xs"></i>
                    Corporate Client
                  </label>
                  <div className="relative">
                    <select
                      name="corporate_client"
                      value={shipmentDetails.corporate_client}
                      onChange={(e) => handleInputChange(e, setShipmentDetails)}
                      className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md appearance-none"
                    >
                      <option value="">Select Client</option>
                      {corporateClients.map((client) => (
                        <option key={client} value={client}>
                          {client}
                        </option>
                      ))}
                    </select>
                    <div className="absolute inset-y-0 right-0 flex items-center pr-4 pointer-events-none">
                      <i className="fas fa-chevron-down text-blue text-sm"></i>
                    </div>
                  </div>
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-ship text-blue text-xs"></i>
                    Carrier / Forwarder
                  </label>
                  <input
                    type="text"
                    name="carrier_forwarder"
                    value={shipmentDetails.carrier_forwarder}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                    placeholder="Enter carrier or forwarder"
                    onChange={(e) => handleInputChange(e, setShipmentDetails)}
                  />
                </div>
                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-file-invoice text-blue text-xs"></i>
                    Master Waybill
                  </label>
                  <input
                    type="text"
                    name="masterWaybill"
                    value={shipmentDetails.masterWaybill}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                    placeholder="Enter master waybill number"
                    onChange={(e) => handleInputChange(e, setShipmentDetails)}
                  />
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-file-invoice text-blue text-xs"></i>
                    House Waybill
                  </label>
                  <input
                    type="text"
                    name="houseWaybill"
                    value={shipmentDetails.houseWaybill}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                    placeholder="Enter house waybill number"
                    onChange={(e) => handleInputChange(e, setShipmentDetails)}
                  />
                </div>
                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-handshake text-blue text-xs"></i>
                    Shipment Terms
                  </label>
                  <div className="relative">
                    <select
                      name="terms"
                      className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md appearance-none disabled:bg-gray-50 disabled:cursor-not-allowed"
                      value={shipmentDetails.terms}
                      onChange={(e) => handleInputChange(e, setShipmentDetails)}
                      disabled={shipmentDetails.shipment_transport === "AIR"}
                    >
                      <option value="">Select Terms</option>
                      <option value="FCL">Full Container Load (FCL)</option>
                      <option value="LCL">
                        Less than Container Load (LCL)
                      </option>
                    </select>
                    <div className="absolute inset-y-0 right-0 flex items-center pr-4 pointer-events-none">
                      <i className="fas fa-chevron-down text-blue text-sm"></i>
                    </div>
                  </div>
                </div>
                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-file-invoice text-blue text-xs"></i>
                    Master Waybill
                  </label>
                  <input
                    type="text"
                    name="masterWaybill"
                    value={shipmentDetails.masterWaybill}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                    placeholder="Enter master waybill number"
                    onChange={(e) => handleInputChange(e, setShipmentDetails)}
                  />
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-file-invoice text-blue text-xs"></i>
                    House Waybill
                  </label>
                  <input
                    type="text"
                    name="houseWaybill"
                    value={shipmentDetails.houseWaybill}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                    placeholder="Enter house waybill number"
                    onChange={(e) => handleInputChange(e, setShipmentDetails)}
                  />
                </div>
                {/* LCL Fields */}
                {shipmentDetails.terms === "LCL" && (
                  <>
                    <div className="space-y-2">
                      <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                        <i className="fas fa-boxes text-blue text-xs"></i>
                        Shipment Packages
                      </label>
                      <input
                        type="text"
                        name="packages"
                        value={shipmentDetails.packages}
                        className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                        placeholder="Number of packages"
                        onChange={(e) =>
                          handleInputChange(e, setShipmentDetails)
                        }
                      />
                    </div>

                    <div className="space-y-2">
                      <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                        <i className="fas fa-weight-hanging text-blue text-xs"></i>
                        Gross Weight
                      </label>
                      <input
                        type="text"
                        name="gross_weight"
                        value={shipmentDetails.gross_weight}
                        className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                        placeholder="Shipment gross weight"
                        onChange={(e) =>
                          handleInputChange(e, setShipmentDetails)
                        }
                      />
                    </div>

                    <div className="space-y-2">
                      <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                        <i className="fas fa-cube text-blue text-xs"></i>
                        Total Volume
                      </label>
                      <input
                        type="text"
                        name="volume"
                        value={shipmentDetails.volume}
                        className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                        placeholder="Shipment total volume"
                        onChange={(e) =>
                          handleInputChange(e, setShipmentDetails)
                        }
                      />
                    </div>
                  </>
                )}

                {/* FCL Fields */}
                {shipmentDetails.terms === "FCL" && (
                  <div className="md:col-span-2 space-y-4">
                    <button
                      className="w-full bg-blue hover:bg-blue/90 text-white py-3 px-6 rounded-2xl font-medium transition-all duration-300 transform hover:scale-[1.02] shadow-md hover:shadow-lg flex items-center justify-center gap-2"
                      onClick={addContainer}
                    >
                      <i className="fas fa-plus text-sm"></i>
                      Add Container
                    </button>

                    <div className="space-y-3">
                      {shipmentDetails.containers.map((item, index) => (
                        <div
                          key={index}
                          className="flex items-center gap-4 p-4 bg-gray-50 rounded-2xl"
                        >
                          <span className="text-blue font-semibold text-sm min-w-[24px]">
                            {index + 1}.
                          </span>
                          <input
                            type="text"
                            name="containerNumber"
                            value={item}
                            className="flex-1 p-3 border-2 border-gray-200 rounded-xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300"
                            placeholder="Container number"
                            onChange={(e) => handleContainerChange(e, index)}
                          />
                          <button
                            type="button"
                            onClick={() => handleDeleteContainer(index)}
                            className="w-10 h-10 bg-red-500 hover:bg-red-600 text-white rounded-xl transition-all duration-200 flex items-center justify-center"
                          >
                            <i className="fas fa-times text-sm"></i>
                          </button>
                        </div>
                      ))}
                    </div>

                    <div className="space-y-2">
                      <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                        <i className="fas fa-weight text-blue text-xs"></i>
                        Total Weight
                      </label>
                      <input
                        type="text"
                        name="total_weight"
                        value={shipmentDetails.total_weight}
                        className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                        placeholder="Shipment total weight"
                        onChange={(e) =>
                          handleInputChange(e, setShipmentDetails)
                        }
                      />
                    </div>

                    <div className="space-y-2">
                      <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                        <i className="fas fa-weight-hanging text-blue text-xs"></i>
                        Gross Weight
                      </label>
                      <input
                        type="text"
                        name="gross_weight"
                        value={shipmentDetails.gross_weight}
                        className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                        placeholder="Shipment gross weight"
                        onChange={(e) =>
                          handleInputChange(e, setShipmentDetails)
                        }
                      />
                    </div>

                    <div className="space-y-2">
                      <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                        <i className="fas fa-cube text-blue text-xs"></i>
                        Total Volume
                      </label>
                      <input
                        type="text"
                        name="volume"
                        value={shipmentDetails.volume}
                        className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                        placeholder="Shipment total volume"
                        onChange={(e) =>
                          handleInputChange(e, setShipmentDetails)
                        }
                      />
                    </div>

                    <div className="space-y-2">
                      <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                        <i className="fas fa-boxes text-blue text-xs"></i>
                        No. of Packages
                      </label>
                      <input
                        type="text"
                        name="packages"
                        value={shipmentDetails.packages}
                        className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                        placeholder="Number of packages"
                        onChange={(e) =>
                          handleInputChange(e, setShipmentDetails)
                        }
                      />
                    </div>
                  </div>
                )}
<div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-file-invoice text-blue text-xs"></i>
                    Master Waybill
                  </label>
                  <input
                    type="text"
                    name="masterWaybill"
                    value={shipmentDetails.masterWaybill}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                    placeholder="Enter master waybill number"
                    onChange={(e) => handleInputChange(e, setShipmentDetails)}
                  />
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-file-invoice text-blue text-xs"></i>
                    House Waybill
                  </label>
                  <input
                    type="text"
                    name="houseWaybill"
                    value={shipmentDetails.houseWaybill}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                    placeholder="Enter house waybill number"
                    onChange={(e) => handleInputChange(e, setShipmentDetails)}
                  />
                </div>
                {/* Date and Remark Fields */}
                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-calendar-alt text-blue text-xs"></i>
                    ETD
                  </label>
                  <input
                    type="date"
                    name="etd"
                    value={shipmentDetails.etd}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                    onChange={(e) => handleInputChange(e, setShipmentDetails)}
                  />
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-calendar-check text-blue text-xs"></i>
                    ETA
                  </label>
                  <input
                    type="date"
                    name="eta"
                    value={shipmentDetails.eta}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                    onChange={(e) => handleInputChange(e, setShipmentDetails)}
                  />
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-calendar-plus text-blue text-xs"></i>
                    Nomination Date
                  </label>
                  <input
                    type="datetime-local"
                    name="receivedDate"
                    value={shipmentDetails.receivedDate}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                    onChange={(e) => handleInputChange(e, setShipmentDetails)}
                  />
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-comment text-blue text-xs"></i>
                    Remarks
                  </label>
                  <textarea
                    name="remark"
                    value={shipmentDetails.remark}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md min-h-[100px] resize-none"
                    placeholder="Enter remarks (optional)"
                    onChange={(e) => handleInputChange(e, setShipmentDetails)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    // DOMESTIC SHIPMENT
    if (currentStep === 3 && shipmentDetails.type === "DOMESTIC") {
      return (
        <div className="w-full max-w-6xl mx-auto">
          <div className="rounded-3xl shadow-xl border border-white/20 overflow-hidden">
            <div className="bg-blue px-8 py-6">
              <div className="flex items-center gap-4">
                <div className="p-3 bg-white/20 rounded-2xl">
                  <i className="fas fa-map text-white text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-white font-bold text-2xl">
                    Domestic Shipment Details
                  </h3>
                  <p className="text-white/80">
                    Configure your local transport service
                  </p>
                </div>
              </div>
            </div>

            <div className="p-8 bg-white/95 backdrop-blur-sm">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-box text-blue text-xs"></i>
                    Shipment Commodity
                  </label>
                  <input
                    type="text"
                    name="commodity"
                    value={shipmentDetails.commodity}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                    placeholder="Enter commodity description"
                    onChange={(e) => handleInputChange(e, setShipmentDetails)}
                  />
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-tag text-blue text-xs"></i>
                    Shipment Type
                  </label>
                  <input
                    type="text"
                    name="type"
                    value={shipmentDetails.type}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl bg-gray-50 text-grey cursor-not-allowed"
                    disabled
                  />
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-cubes text-blue text-xs"></i>
                    Number of Pieces
                  </label>
                  <input
                    type="text"
                    name="number_pcs"
                    value={shipmentDetails.number_pcs}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                    placeholder="Number of pieces"
                    onChange={(e) => handleInputChange(e, setShipmentDetails)}
                  />
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-cube text-blue text-xs"></i>
                    CBM
                  </label>
                  <input
                    type="text"
                    name="cbm"
                    value={shipmentDetails.cbm}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                    placeholder="Cubic meter measurement"
                    onChange={(e) => handleInputChange(e, setShipmentDetails)}
                  />
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-compass text-blue text-xs"></i>
                    Shipment Bound
                  </label>
                  <div className="relative">
                    <select
                      name="shipment_bound"
                      value={shipmentDetails.shipment_bound}
                      onChange={(e) => handleInputChange(e, setShipmentDetails)}
                      className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md appearance-none"
                    >
                      <option value="">Select Direction</option>
                      <option value="INBOUND">Inbound</option>
                      <option value="OUTBOUND">Outbound</option>
                    </select>
                    <div className="absolute inset-y-0 right-0 flex items-center pr-4 pointer-events-none">
                      <i className="fas fa-chevron-down text-blue text-sm"></i>
                    </div>
                  </div>
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-shipping-fast text-blue text-xs"></i>
                    Transport Mode
                  </label>
                  <div className="relative">
                    <select
                      name="shipment_transport"
                      value={shipmentDetails.shipment_transport}
                      onChange={(e) => handleInputChange(e, setShipmentDetails)}
                      className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md appearance-none"
                    >
                      <option value="">Select Transport</option>
                      <option value="AIR">Air Transport</option>
                      <option value="SEA">Sea Transport</option>
                    </select>
                    <div className="absolute inset-y-0 right-0 flex items-center pr-4 pointer-events-none">
                      <i className="fas fa-chevron-down text-blue text-sm"></i>
                    </div>
                  </div>
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-handshake text-blue text-xs"></i>
                    Shipment Terms
                  </label>
                  <div className="relative">
                    <select
                      name="terms"
                      className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md appearance-none disabled:bg-gray-50"
                      value={shipmentDetails.terms}
                      disabled={shipmentDetails.shipment_transport === "AIR"}
                      onChange={(e) => handleInputChange(e, setShipmentDetails)}
                    >
                      <option value="">Select Terms</option>
                      <option value="FCL">Full Container Load (FCL)</option>
                      <option value="LCL">
                        Less than Container Load (LCL)
                      </option>
                    </select>
                    <div className="absolute inset-y-0 right-0 flex items-center pr-4 pointer-events-none">
                      <i className="fas fa-chevron-down text-blue text-sm"></i>
                    </div>
                  </div>
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-building text-blue text-xs"></i>
                    Corporate Client
                  </label>
                  <div className="relative">
                    <select
                      name="corporate_client"
                      value={shipmentDetails.corporate_client}
                      onChange={(e) => handleInputChange(e, setShipmentDetails)}
                      className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md appearance-none"
                    >
                      <option value="">Select Client</option>
                      {corporateClients.map((client) => (
                        <option key={client} value={client}>
                          {client}
                        </option>
                      ))}
                    </select>
                    <div className="absolute inset-y-0 right-0 flex items-center pr-4 pointer-events-none">
                      <i className="fas fa-chevron-down text-blue text-sm"></i>
                    </div>
                  </div>
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-ship text-blue text-xs"></i>
                    Carrier / Forwarder
                  </label>
                  <input
                    type="text"
                    name="carrier_forwarder"
                    value={shipmentDetails.carrier_forwarder}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                    placeholder="Enter carrier or forwarder"
                    onChange={(e) => handleInputChange(e, setShipmentDetails)}
                  />
                </div>
                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-file-invoice text-blue text-xs"></i>
                    Master Waybill
                  </label>
                  <input
                    type="text"
                    name="masterWaybill"
                    value={shipmentDetails.masterWaybill}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                    placeholder="Enter master waybill number"
                    onChange={(e) => handleInputChange(e, setShipmentDetails)}
                  />
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-file-invoice text-blue text-xs"></i>
                    House Waybill
                  </label>
                  <input
                    type="text"
                    name="houseWaybill"
                    value={shipmentDetails.houseWaybill}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                    placeholder="Enter house waybill number"
                    onChange={(e) => handleInputChange(e, setShipmentDetails)}
                  />
                </div>
                {/* LCL Fields */}
                {shipmentDetails.terms === "LCL" && (
                  <>
                    <div className="space-y-2">
                      <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                        <i className="fas fa-boxes text-blue text-xs"></i>
                        Shipment Packages
                      </label>
                      <input
                        type="text"
                        name="packages"
                        value={shipmentDetails.packages}
                        className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                        placeholder="Number of packages"
                        onChange={(e) =>
                          handleInputChange(e, setShipmentDetails)
                        }
                      />
                    </div>

                    <div className="space-y-2">
                      <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                        <i className="fas fa-weight-hanging text-blue text-xs"></i>
                        Gross Weight
                      </label>
                      <input
                        type="text"
                        name="gross_weight"
                        value={shipmentDetails.gross_weight}
                        className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                        placeholder="Shipment gross weight"
                        onChange={(e) =>
                          handleInputChange(e, setShipmentDetails)
                        }
                      />
                    </div>

                    <div className="space-y-2">
                      <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                        <i className="fas fa-cube text-blue text-xs"></i>
                        Total Volume
                      </label>
                      <input
                        type="text"
                        name="volume"
                        value={shipmentDetails.volume}
                        className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                        placeholder="Shipment total volume"
                        onChange={(e) =>
                          handleInputChange(e, setShipmentDetails)
                        }
                      />
                    </div>
                  </>
                )}

                {/* FCL Container Management */}
                {shipmentDetails.terms === "FCL" && (
                  <div className="md:col-span-2 space-y-4">
                    <button
                      className="w-full bg-blue hover:bg-blue/90 text-white py-3 px-6 rounded-2xl font-medium transition-all duration-300 transform hover:scale-[1.02] shadow-md hover:shadow-lg flex items-center justify-center gap-2"
                      onClick={addContainer}
                    >
                      <i className="fas fa-plus text-sm"></i>
                      Add Container
                    </button>

                    <div className="space-y-3">
                      {shipmentDetails.containers.map((item, index) => (
                        <div
                          key={index}
                          className="flex items-center gap-4 p-4 bg-gray-50 rounded-2xl"
                        >
                          <span className="text-blue font-semibold text-sm min-w-[24px]">
                            {index + 1}.
                          </span>
                          <input
                            type="text"
                            name="containerNumber"
                            value={item}
                            className="flex-1 p-3 border-2 border-gray-200 rounded-xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300"
                            placeholder="Container number"
                            onChange={(e) => handleContainerChange(e, index)}
                          />
                          <button
                            type="button"
                            onClick={() => handleDeleteContainer(index)}
                            className="w-10 h-10 bg-red-500 hover:bg-red-600 text-white rounded-xl transition-all duration-200 flex items-center justify-center"
                          >
                            <i className="fas fa-times text-sm"></i>
                          </button>
                        </div>
                      ))}
                    </div>

                    <div className="space-y-2">
                      <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                        <i className="fas fa-weight text-blue text-xs"></i>
                        Total Weight
                      </label>
                      <input
                        type="text"
                        name="total_weight"
                        value={shipmentDetails.total_weight}
                        className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                        placeholder="Shipment total weight"
                        onChange={(e) =>
                          handleInputChange(e, setShipmentDetails)
                        }
                      />
                    </div>

                    <div className="space-y-2">
                      <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                        <i className="fas fa-weight-hanging text-blue text-xs"></i>
                        Gross Weight
                      </label>
                      <input
                        type="text"
                        name="gross_weight"
                        value={shipmentDetails.gross_weight}
                        className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                        placeholder="Shipment gross weight"
                        onChange={(e) =>
                          handleInputChange(e, setShipmentDetails)
                        }
                      />
                    </div>

                    <div className="space-y-2">
                      <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                        <i className="fas fa-cube text-blue text-xs"></i>
                        Total Volume
                      </label>
                      <input
                        type="text"
                        name="volume"
                        value={shipmentDetails.volume}
                        className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                        placeholder="Shipment total volume"
                        onChange={(e) =>
                          handleInputChange(e, setShipmentDetails)
                        }
                      />
                    </div>

                    <div className="space-y-2">
                      <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                        <i className="fas fa-boxes text-blue text-xs"></i>
                        No. of Packages
                      </label>
                      <input
                        type="text"
                        name="packages"
                        value={shipmentDetails.packages}
                        className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                        placeholder="Number of packages"
                        onChange={(e) =>
                          handleInputChange(e, setShipmentDetails)
                        }
                      />
                    </div>
                  </div>
                )}

                {/* Weight and Location Fields */}
                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-weight-hanging text-blue text-xs"></i>
                    Gross Weight
                  </label>
                  <input
                    type="text"
                    name="gross_weight"
                    value={shipmentDetails.gross_weight}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                    placeholder="Shipment gross weight"
                    onChange={(e) => handleInputChange(e, setShipmentDetails)}
                  />
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-balance-scale text-blue text-xs"></i>
                    Chargeable Weight
                  </label>
                  <input
                    type="text"
                    name="chargeable_weight"
                    value={shipmentDetails.chargeable_weight}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                    placeholder="Shipment chargeable weight"
                    onChange={(e) => handleInputChange(e, setShipmentDetails)}
                  />
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-map-marker-alt text-blue text-xs"></i>
                    Origin
                  </label>
                  <input
                    type="text"
                    name="origin"
                    value={shipmentDetails.origin}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                    placeholder="Shipment origin"
                    onChange={(e) => handleInputChange(e, setShipmentDetails)}
                  />
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-map-pin text-blue text-xs"></i>
                    Destination
                  </label>
                  <input
                    type="text"
                    name="destination"
                    value={shipmentDetails.destination}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                    placeholder="Shipment destination"
                    onChange={(e) => handleInputChange(e, setShipmentDetails)}
                  />
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-plane text-blue text-xs"></i>
                    Flight
                  </label>
                  <input
                    type="text"
                    name="flight"
                    value={shipmentDetails.flight}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                    placeholder="Flight details (Air only)"
                    onChange={(e) => handleInputChange(e, setShipmentDetails)}
                  />
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-code text-blue text-xs"></i>
                    Job Order Code
                  </label>
                  <input
                    type="text"
                    name="job_order"
                    value={shipmentDetails.job_order}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md font-mono"
                    placeholder="Auto-generated code"
                    onChange={handleJobOrderChange}
                  />
                  {joError && (
                    <p className="text-red-500 text-xs mt-1">{joError}</p>
                  )}
                </div>
                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-file-invoice text-blue text-xs"></i>
                    Master Waybill
                  </label>
                  <input
                    type="text"
                    name="masterWaybill"
                    value={shipmentDetails.masterWaybill}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                    placeholder="Enter master waybill number"
                    onChange={(e) => handleInputChange(e, setShipmentDetails)}
                  />
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-file-invoice text-blue text-xs"></i>
                    House Waybill
                  </label>
                  <input
                    type="text"
                    name="houseWaybill"
                    value={shipmentDetails.houseWaybill}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                    placeholder="Enter house waybill number"
                    onChange={(e) => handleInputChange(e, setShipmentDetails)}
                  />
                </div>
                {/* Dimensions Section */}
                <div className="md:col-span-2 space-y-4">
                  <button
                    className="w-full bg-blue hover:bg-blue/90 text-white py-3 px-6 rounded-2xl font-medium transition-all duration-300 transform hover:scale-[1.02] shadow-md hover:shadow-lg flex items-center justify-center gap-2"
                    onClick={addDimension}
                  >
                    <i className="fas fa-plus text-sm"></i>
                    Add Shipment Dimension
                  </button>

                  <div className="space-y-3">
                    {shipmentDetails.dimensions.map((item, index) => (
                      <div
                        key={index}
                        className="flex items-center gap-4 p-4 bg-gray-50 rounded-2xl"
                      >
                        <span className="text-blue font-semibold text-sm min-w-[24px]">
                          {index + 1}.
                        </span>
                        <input
                          type="text"
                          name="dimension"
                          value={item}
                          className="flex-1 p-3 border-2 border-gray-200 rounded-xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300"
                          placeholder="Add shipment dimension"
                          onChange={(e) => handleDimensionChange(e, index)}
                        />
                        <button
                          type="button"
                          onClick={() => handleDeleteDimension(index)}
                          className="w-10 h-10 bg-red-500 hover:bg-red-600 text-white rounded-xl transition-all duration-200 flex items-center justify-center"
                        >
                          <i className="fas fa-times text-sm"></i>
                        </button>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Date and Remark Fields */}
                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-calendar-alt text-blue text-xs"></i>
                    ETD
                  </label>
                  <input
                    type="date"
                    name="etd"
                    value={shipmentDetails.etd}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                    onChange={(e) => handleInputChange(e, setShipmentDetails)}
                  />
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-calendar-check text-blue text-xs"></i>
                    ETA
                  </label>
                  <input
                    type="date"
                    name="eta"
                    value={shipmentDetails.eta}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                    onChange={(e) => handleInputChange(e, setShipmentDetails)}
                  />
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-calendar-plus text-blue text-xs"></i>
                    Nomination Date
                  </label>
                  <input
                    type="datetime-local"
                    name="receivedDate"
                    value={shipmentDetails.receivedDate}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                    onChange={(e) => handleInputChange(e, setShipmentDetails)}
                  />
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-comment text-blue text-xs"></i>
                    Remarks
                  </label>
                  <textarea
                    name="remark"
                    value={shipmentDetails.remark}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md min-h-[100px] resize-none"
                    placeholder="Enter remarks (optional)"
                    onChange={(e) => handleInputChange(e, setShipmentDetails)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    // LAND SHIPMENT
    if (currentStep === 3 && shipmentDetails.type === "LAND") {
      return (
        <div className="w-full max-w-6xl mx-auto">
          <div className="rounded-3xl shadow-xl border border-white/20 overflow-hidden">
            <div className="bg-blue px-8 py-6">
              <div className="flex items-center gap-4">
                <div className="p-3 bg-white/20 rounded-2xl">
                  <i className="fas fa-truck text-white text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-white font-bold text-2xl">
                    Land Transport Details
                  </h3>
                  <p className="text-white/80">
                    Configure your road transport service
                  </p>
                </div>
              </div>
            </div>

            <div className="p-8 bg-white/95 backdrop-blur-sm">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-box text-blue text-xs"></i>
                    Shipment Commodity
                  </label>
                  <input
                    type="text"
                    name="commodity"
                    value={shipmentDetails.commodity}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                    placeholder="Enter commodity description"
                    onChange={(e) => handleInputChange(e, setShipmentDetails)}
                  />
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-tag text-blue text-xs"></i>
                    Shipment Type
                  </label>
                  <input
                    type="text"
                    name="type"
                    value={shipmentDetails.type}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl bg-gray-50 text-grey cursor-not-allowed"
                    disabled
                  />
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-weight-hanging text-blue text-xs"></i>
                    Gross Weight
                  </label>
                  <input
                    type="text"
                    name="gross_weight"
                    value={shipmentDetails.gross_weight}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                    placeholder="Shipment gross weight"
                    onChange={(e) => handleInputChange(e, setShipmentDetails)}
                  />
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-truck text-blue text-xs"></i>
                    Truck Details
                  </label>
                  <input
                    type="text"
                    name="truck_type"
                    value={shipmentDetails.truck_type}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                    placeholder="Plate number, truck type, etc."
                    onChange={(e) => handleInputChange(e, setShipmentDetails)}
                  />
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-code text-blue text-xs"></i>
                    Job Order Code
                  </label>
                  <input
                    type="text"
                    name="job_order"
                    value={shipmentDetails.job_order}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md font-mono"
                    placeholder="Auto-generated code"
                    onChange={handleJobOrderChange}
                  />
                  {joError && (
                    <p className="text-red-500 text-xs mt-1">{joError}</p>
                  )}
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-cubes text-blue text-xs"></i>
                    Number of Pieces
                  </label>
                  <input
                    type="text"
                    name="number_pcs"
                    value={shipmentDetails.number_pcs}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                    placeholder="Number of pieces"
                    onChange={(e) => handleInputChange(e, setShipmentDetails)}
                  />
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-building text-blue text-xs"></i>
                    Corporate Client
                  </label>
                  <div className="relative">
                    <select
                      name="corporate_client"
                      value={shipmentDetails.corporate_client}
                      onChange={(e) => handleInputChange(e, setShipmentDetails)}
                      className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md appearance-none"
                    >
                      <option value="">Select Client</option>
                      {corporateClients.map((client) => (
                        <option key={client} value={client}>
                          {client}
                        </option>
                      ))}
                    </select>
                    <div className="absolute inset-y-0 right-0 flex items-center pr-4 pointer-events-none">
                      <i className="fas fa-chevron-down text-blue text-sm"></i>
                    </div>
                  </div>
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-ship text-blue text-xs"></i>
                    Carrier / Forwarder
                  </label>
                  <input
                    type="text"
                    name="carrier_forwarder"
                    value={shipmentDetails.carrier_forwarder}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                    placeholder="Enter carrier or forwarder"
                    onChange={(e) => handleInputChange(e, setShipmentDetails)}
                  />
                </div>

                {/* Date and Remark Fields */}
                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-calendar-alt text-blue text-xs"></i>
                    ETD
                  </label>
                  <input
                    type="date"
                    name="etd"
                    value={shipmentDetails.etd}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                    onChange={(e) => handleInputChange(e, setShipmentDetails)}
                  />
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-calendar-check text-blue text-xs"></i>
                    ETA
                  </label>
                  <input
                    type="date"
                    name="eta"
                    value={shipmentDetails.eta}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                    onChange={(e) => handleInputChange(e, setShipmentDetails)}
                  />
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-calendar-plus text-blue text-xs"></i>
                    Nomination Date
                  </label>
                  <input
                    type="datetime-local"
                    name="receivedDate"
                    value={shipmentDetails.receivedDate}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                    onChange={(e) => handleInputChange(e, setShipmentDetails)}
                  />
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-comment text-blue text-xs"></i>
                    Remarks
                  </label>
                  <textarea
                    name="remark"
                    value={shipmentDetails.remark}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md min-h-[100px] resize-none"
                    placeholder="Enter remarks (optional)"
                    onChange={(e) => handleInputChange(e, setShipmentDetails)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    // SEA SHIPMENT
    if (currentStep === 3 && shipmentDetails.type === "SEA") {
      return (
        <div className="w-full max-w-6xl mx-auto">
          <div className="rounded-3xl shadow-xl border border-white/20 overflow-hidden">
            <div className="bg-blue px-8 py-6">
              <div className="flex items-center gap-4">
                <div className="p-3 bg-white/20 rounded-2xl">
                  <i className="fas fa-ship text-white text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-white font-bold text-2xl">
                    Sea Freight Details
                  </h3>
                  <p className="text-white/80">
                    Configure your ocean transport service
                  </p>
                </div>
              </div>
            </div>

            <div className="p-8 bg-white/95 backdrop-blur-sm">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-file-alt text-blue text-xs"></i>
                    Shipment Description
                  </label>
                  <input
                    type="text"
                    name="description"
                    value={shipmentDetails.description}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                    placeholder="Enter shipment description"
                    onChange={(e) => handleInputChange(e, setShipmentDetails)}
                  />
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-tag text-blue text-xs"></i>
                    Shipment Type
                  </label>
                  <input
                    type="text"
                    name="type"
                    value={shipmentDetails.type}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl bg-gray-50 text-grey cursor-not-allowed"
                    disabled
                  />
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-arrow-right text-blue text-xs"></i>
                    Shipment Mode
                  </label>
                  <div className="relative">
                    <select
                      name="shipment_mode"
                      value={shipmentDetails.shipment_mode}
                      onChange={(e) => handleInputChange(e, setShipmentDetails)}
                      className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md appearance-none"
                    >
                      <option value="">Select Mode</option>
                      <option value="EXPORT">Export</option>
                      <option value="IMPORT">Import</option>
                      <option value="EXPORT-EVENT">Export Event</option>
                      <option value="IMPORT-EVENT">Import Event</option>
                    </select>
                    <div className="absolute inset-y-0 right-0 flex items-center pr-4 pointer-events-none">
                      <i className="fas fa-chevron-down text-blue text-sm"></i>
                    </div>
                  </div>
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-truck text-blue text-xs"></i>
                    Delivery Mode
                  </label>
                  <div className="relative">
                    <select
                      name="delivery_mode"
                      value={shipmentDetails.delivery_mode}
                      onChange={(e) => handleInputChange(e, setShipmentDetails)}
                      className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md appearance-none"
                    >
                      <option value="">Select Delivery Mode</option>
                      <option value="DOOR-DOOR">Door to Door</option>
                      <option value="DOOR-PORT">Door to Port</option>
                      <option value="PORT-PORT">Port to Port</option>
                      <option value="PORT-DOOR">Port to Door</option>
                    </select>
                    <div className="absolute inset-y-0 right-0 flex items-center pr-4 pointer-events-none">
                      <i className="fas fa-chevron-down text-blue text-sm"></i>
                    </div>
                  </div>
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-handshake text-blue text-xs"></i>
                    Shipment Terms
                  </label>
                  <div className="relative">
                    <select
                      name="terms"
                      className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md appearance-none"
                      value={shipmentDetails.terms}
                      onChange={(e) => handleInputChange(e, setShipmentDetails)}
                    >
                      <option value="">Select Terms</option>
                      <option value="FCL">Full Container Load (FCL)</option>
                      <option value="LCL">
                        Less than Container Load (LCL)
                      </option>
                    </select>
                    <div className="absolute inset-y-0 right-0 flex items-center pr-4 pointer-events-none">
                      <i className="fas fa-chevron-down text-blue text-sm"></i>
                    </div>
                  </div>
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-code text-blue text-xs"></i>
                    Job Order Code
                  </label>
                  <input
                    type="text"
                    name="job_order"
                    value={shipmentDetails.job_order}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md font-mono"
                    placeholder="Auto-generated code"
                    onChange={handleJobOrderChange}
                  />
                  {joError && (
                    <p className="text-red-500 text-xs mt-1">{joError}</p>
                  )}
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-building text-blue text-xs"></i>
                    Corporate Client
                  </label>
                  <div className="relative">
                    <select
                      name="corporate_client"
                      value={shipmentDetails.corporate_client}
                      onChange={(e) => handleInputChange(e, setShipmentDetails)}
                      className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md appearance-none"
                    >
                      <option value="">Select Client</option>
                      {corporateClients.map((client) => (
                        <option key={client} value={client}>
                          {client}
                        </option>
                      ))}
                    </select>
                    <div className="absolute inset-y-0 right-0 flex items-center pr-4 pointer-events-none">
                      <i className="fas fa-chevron-down text-blue text-sm"></i>
                    </div>
                  </div>
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-ship text-blue text-xs"></i>
                    Carrier / Forwarder
                  </label>
                  <input
                    type="text"
                    name="carrier_forwarder"
                    value={shipmentDetails.carrier_forwarder}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                    placeholder="Enter carrier or forwarder"
                    onChange={(e) => handleInputChange(e, setShipmentDetails)}
                  />
                </div>

                {/* LCL Fields */}
                {shipmentDetails.terms === "LCL" && (
                  <>
                    <div className="space-y-2">
                      <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                        <i className="fas fa-boxes text-blue text-xs"></i>
                        Shipment Packages
                      </label>
                      <input
                        type="text"
                        name="packages"
                        value={shipmentDetails.packages}
                        className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                        placeholder="Number of packages"
                        onChange={(e) =>
                          handleInputChange(e, setShipmentDetails)
                        }
                      />
                    </div>

                    <div className="space-y-2">
                      <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                        <i className="fas fa-weight-hanging text-blue text-xs"></i>
                        Gross Weight
                      </label>
                      <input
                        type="text"
                        name="gross_weight"
                        value={shipmentDetails.gross_weight}
                        className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                        placeholder="Shipment gross weight"
                        onChange={(e) =>
                          handleInputChange(e, setShipmentDetails)
                        }
                      />
                    </div>

                    <div className="space-y-2">
                      <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                        <i className="fas fa-cube text-blue text-xs"></i>
                        Total Volume
                      </label>
                      <input
                        type="text"
                        name="volume"
                        value={shipmentDetails.volume}
                        className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                        placeholder="Shipment total volume"
                        onChange={(e) =>
                          handleInputChange(e, setShipmentDetails)
                        }
                      />
                    </div>
                  </>
                )}

                {/* FCL Container Management */}
                {shipmentDetails.terms === "FCL" && (
                  <div className="md:col-span-2 space-y-4">
                    <button
                      className="w-full bg-blue hover:bg-blue/90 text-white py-3 px-6 rounded-2xl font-medium transition-all duration-300 transform hover:scale-[1.02] shadow-md hover:shadow-lg flex items-center justify-center gap-2"
                      onClick={addContainer}
                    >
                      <i className="fas fa-plus text-sm"></i>
                      Add Container
                    </button>

                    <div className="space-y-3">
                      {shipmentDetails.containers.map((item, index) => (
                        <div
                          key={index}
                          className="flex items-center gap-4 p-4 bg-gray-50 rounded-2xl"
                        >
                          <span className="text-blue font-semibold text-sm min-w-[24px]">
                            {index + 1}.
                          </span>
                          <input
                            type="text"
                            name="containerNumber"
                            value={item}
                            className="flex-1 p-3 border-2 border-gray-200 rounded-xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300"
                            placeholder="Container number"
                            onChange={(e) => handleContainerChange(e, index)}
                          />
                          <button
                            type="button"
                            onClick={() => handleDeleteContainer(index)}
                            className="w-10 h-10 bg-red-500 hover:bg-red-600 text-white rounded-xl transition-all duration-200 flex items-center justify-center"
                          >
                            <i className="fas fa-times text-sm"></i>
                          </button>
                        </div>
                      ))}
                    </div>

                    <div className="space-y-2">
                      <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                        <i className="fas fa-weight text-blue text-xs"></i>
                        Total Weight
                      </label>
                      <input
                        type="text"
                        name="total_weight"
                        value={shipmentDetails.total_weight}
                        className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                        placeholder="Shipment total weight"
                        onChange={(e) =>
                          handleInputChange(e, setShipmentDetails)
                        }
                      />
                    </div>

                    <div className="space-y-2">
                      <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                        <i className="fas fa-weight-hanging text-blue text-xs"></i>
                        Gross Weight
                      </label>
                      <input
                        type="text"
                        name="gross_weight"
                        value={shipmentDetails.gross_weight}
                        className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                        placeholder="Shipment gross weight"
                        onChange={(e) =>
                          handleInputChange(e, setShipmentDetails)
                        }
                      />
                    </div>

                    <div className="space-y-2">
                      <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                        <i className="fas fa-cube text-blue text-xs"></i>
                        Total Volume
                      </label>
                      <input
                        type="text"
                        name="volume"
                        value={shipmentDetails.volume}
                        className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                        placeholder="Shipment total volume"
                        onChange={(e) =>
                          handleInputChange(e, setShipmentDetails)
                        }
                      />
                    </div>

                    <div className="space-y-2">
                      <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                        <i className="fas fa-boxes text-blue text-xs"></i>
                        No. of Packages
                      </label>
                      <input
                        type="text"
                        name="packages"
                        value={shipmentDetails.packages}
                        className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                        placeholder="Number of packages"
                        onChange={(e) =>
                          handleInputChange(e, setShipmentDetails)
                        }
                      />
                    </div>
                  </div>
                )}

                {/* Date and Remark Fields */}
                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-calendar-alt text-blue text-xs"></i>
                    ETD
                  </label>
                  <input
                    type="date"
                    name="etd"
                    value={shipmentDetails.etd}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                    onChange={(e) => handleInputChange(e, setShipmentDetails)}
                  />
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-calendar-check text-blue text-xs"></i>
                    ETA
                  </label>
                  <input
                    type="date"
                    name="eta"
                    value={shipmentDetails.eta}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                    onChange={(e) => handleInputChange(e, setShipmentDetails)}
                  />
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-calendar-plus text-blue text-xs"></i>
                    Nomination Date
                  </label>
                  <input
                    type="datetime-local"
                    name="receivedDate"
                    value={shipmentDetails.receivedDate}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                    onChange={(e) => handleInputChange(e, setShipmentDetails)}
                  />
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-comment text-blue text-xs"></i>
                    Remarks
                  </label>
                  <textarea
                    name="remark"
                    value={shipmentDetails.remark}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md min-h-[100px] resize-none"
                    placeholder="Enter remarks (optional)"
                    onChange={(e) => handleInputChange(e, setShipmentDetails)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    // AIR SHIPMENT
    if (currentStep === 3 && shipmentDetails.type === "AIR") {
      return (
        <div className="w-full max-w-6xl mx-auto">
          <div className="rounded-3xl shadow-xl border border-white/20 overflow-hidden">
            <div className="bg-blue px-8 py-6">
              <div className="flex items-center gap-4">
                <div className="p-3 bg-white/20 rounded-2xl">
                  <i className="fas fa-plane text-white text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-white font-bold text-2xl">
                    Air Freight Details
                  </h3>
                  <p className="text-white/80">
                    Configure your express air transport service
                  </p>
                </div>
              </div>
            </div>

            <div className="p-8 bg-white/95 backdrop-blur-sm">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-file-alt text-blue text-xs"></i>
                    Shipment Description
                  </label>
                  <input
                    type="text"
                    name="description"
                    value={shipmentDetails.description}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                    placeholder="Enter shipment description"
                    onChange={(e) => handleInputChange(e, setShipmentDetails)}
                  />
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-tag text-blue text-xs"></i>
                    Shipment Type
                  </label>
                  <input
                    type="text"
                    name="type"
                    value={shipmentDetails.type}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl bg-gray-50 text-grey cursor-not-allowed"
                    disabled
                  />
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-arrow-right text-blue text-xs"></i>
                    Shipment Mode
                  </label>
                  <div className="relative">
                    <select
                      name="shipment_mode"
                      value={shipmentDetails.shipment_mode}
                      onChange={(e) => handleInputChange(e, setShipmentDetails)}
                      className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md appearance-none"
                    >
                      <option value="">Select Mode</option>
                      <option value="EXPORT">Export</option>
                      <option value="IMPORT">Import</option>
                      <option value="EXPORT-EVENT">Export Event</option>
                      <option value="IMPORT-EVENT">Import Event</option>
                    </select>
                    <div className="absolute inset-y-0 right-0 flex items-center pr-4 pointer-events-none">
                      <i className="fas fa-chevron-down text-blue text-sm"></i>
                    </div>
                  </div>
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-truck text-blue text-xs"></i>
                    Delivery Mode
                  </label>
                  <div className="relative">
                    <select
                      name="delivery_mode"
                      value={shipmentDetails.delivery_mode}
                      onChange={(e) => handleInputChange(e, setShipmentDetails)}
                      className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md appearance-none"
                    >
                      <option value="">Select Delivery Mode</option>
                      <option value="DOOR-DOOR">Door to Door</option>
                      <option value="DOOR-PORT">Door to Port</option>
                      <option value="PORT-PORT">Port to Port</option>
                      <option value="PORT-DOOR">Port to Door</option>
                    </select>
                    <div className="absolute inset-y-0 right-0 flex items-center pr-4 pointer-events-none">
                      <i className="fas fa-chevron-down text-blue text-sm"></i>
                    </div>
                  </div>
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-code text-blue text-xs"></i>
                    Job Order Code
                  </label>
                  <input
                    type="text"
                    name="job_order"
                    value={shipmentDetails.job_order}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md font-mono"
                    placeholder="Auto-generated code"
                    onChange={handleJobOrderChange}
                  />
                  {joError && (
                    <p className="text-red-500 text-xs mt-1">{joError}</p>
                  )}
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-weight-hanging text-blue text-xs"></i>
                    Gross Weight
                  </label>
                  <input
                    type="text"
                    name="gross_weight"
                    value={shipmentDetails.gross_weight}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                    placeholder="Shipment gross weight"
                    onChange={(e) => handleInputChange(e, setShipmentDetails)}
                  />
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-balance-scale text-blue text-xs"></i>
                    Chargeable Weight
                  </label>
                  <input
                    type="text"
                    name="chargeable_weight"
                    value={shipmentDetails.chargeable_weight}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                    placeholder="Shipment chargeable weight"
                    onChange={(e) => handleInputChange(e, setShipmentDetails)}
                  />
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-building text-blue text-xs"></i>
                    Corporate Client
                  </label>
                  <div className="relative">
                    <select
                      name="corporate_client"
                      value={shipmentDetails.corporate_client}
                      onChange={(e) => handleInputChange(e, setShipmentDetails)}
                      className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md appearance-none"
                    >
                      <option value="">Select Client</option>
                      {corporateClients.map((client) => (
                        <option key={client} value={client}>
                          {client}
                        </option>
                      ))}
                    </select>
                    <div className="absolute inset-y-0 right-0 flex items-center pr-4 pointer-events-none">
                      <i className="fas fa-chevron-down text-blue text-sm"></i>
                    </div>
                  </div>
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-ship text-blue text-xs"></i>
                    Carrier / Forwarder
                  </label>
                  <input
                    type="text"
                    name="carrier_forwarder"
                    value={shipmentDetails.carrier_forwarder}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                    placeholder="Enter carrier or forwarder"
                    onChange={(e) => handleInputChange(e, setShipmentDetails)}
                  />
                </div>

                {/* Dimensions Section */}
                <div className="md:col-span-2 space-y-4">
                  <button
                    className="w-full bg-blue hover:bg-blue/90 text-white py-3 px-6 rounded-2xl font-medium transition-all duration-300 transform hover:scale-[1.02] shadow-md hover:shadow-lg flex items-center justify-center gap-2"
                    onClick={addDimension}
                  >
                    <i className="fas fa-plus text-sm"></i>
                    Add Shipment Dimension
                  </button>

                  <div className="space-y-3">
                    {shipmentDetails.dimensions.map((item, index) => (
                      <div
                        key={index}
                        className="flex items-center gap-4 p-4 bg-gray-50 rounded-2xl"
                      >
                        <span className="text-blue font-semibold text-sm min-w-[24px]">
                          {index + 1}.
                        </span>
                        <input
                          type="text"
                          name="dimension"
                          value={item}
                          className="flex-1 p-3 border-2 border-gray-200 rounded-xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300"
                          placeholder="Add shipment dimension"
                          onChange={(e) => handleDimensionChange(e, index)}
                        />
                        <button
                          type="button"
                          onClick={() => handleDeleteDimension(index)}
                          className="w-10 h-10 bg-red-500 hover:bg-red-600 text-white rounded-xl transition-all duration-200 flex items-center justify-center"
                        >
                          <i className="fas fa-times text-sm"></i>
                        </button>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Date and Remark Fields */}
                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-calendar-alt text-blue text-xs"></i>
                    ETD
                  </label>
                  <input
                    type="date"
                    name="etd"
                    value={shipmentDetails.etd}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                    onChange={(e) => handleInputChange(e, setShipmentDetails)}
                  />
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-calendar-check text-blue text-xs"></i>
                    ETA
                  </label>
                  <input
                    type="date"
                    name="eta"
                    value={shipmentDetails.eta}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                    onChange={(e) => handleInputChange(e, setShipmentDetails)}
                  />
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-calendar-plus text-blue text-xs"></i>
                    Nomination Date
                  </label>
                  <input
                    type="datetime-local"
                    name="receivedDate"
                    value={shipmentDetails.receivedDate}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                    onChange={(e) => handleInputChange(e, setShipmentDetails)}
                  />
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-comment text-blue text-xs"></i>
                    Remarks
                  </label>
                  <textarea
                    name="remark"
                    value={shipmentDetails.remark}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md min-h-[100px] resize-none"
                    placeholder="Enter remarks (optional)"
                    onChange={(e) => handleInputChange(e, setShipmentDetails)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    // CONFIRMATION STEP
    if (currentStep === 4) {
      return (
        <div className="w-full max-w-6xl mx-auto">
          <div className="rounded-3xl shadow-xl border border-white/20 overflow-hidden">
            <div className="bg-blue px-8 py-6">
              <div className="flex items-center gap-4">
                <div className="p-3 bg-white/20 rounded-2xl">
                  <i className="fas fa-clipboard-check text-white text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-white font-bold text-2xl">
                    Review & Confirmation
                  </h3>
                  <p className="text-white/80">
                    Please review all details before submitting
                  </p>
                </div>
              </div>
            </div>

            <div className="p-8 bg-white/95 backdrop-blur-sm space-y-8">
              {/* Shipper Details */}
              <div className="space-y-4">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-8 h-8 bg-blue/10 rounded-xl flex items-center justify-center">
                    <i className="fas fa-user text-blue text-sm"></i>
                  </div>
                  <h4 className="text-blue text-xl font-bold">
                    Shipper Details
                  </h4>
                </div>
                <div className="bg-gray-50 rounded-2xl overflow-hidden">
                  <div className="overflow-x-auto">
                    <table className="w-full">
                      <thead className="bg-blue">
                        <tr>
                          <th className="px-6 py-4 text-left font-semibold text-sm text-white">
                            Field
                          </th>
                          <th className="px-6 py-4 text-left font-semibold text-sm text-white">
                            Value
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {filterEmptyFields(shipperDetails).map(
                          ([key, value], index) => (
                            <tr
                              key={key}
                              className={`${
                                index % 2 === 0 ? "bg-white" : "bg-gray-50"
                              } transition-colors`}
                            >
                              <td className="px-6 py-4 font-medium text-grey capitalize">
                                {key.replace(/_/g, " ")}
                              </td>
                              <td className="px-6 py-4 text-grey">{value}</td>
                            </tr>
                          )
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              {/* Receiver Details */}
              <div className="space-y-4">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-8 h-8 bg-blue/10 rounded-xl flex items-center justify-center">
                    <i className="fas fa-user-tag text-blue text-sm"></i>
                  </div>
                  <h4 className="text-blue text-xl font-bold">
                    Consignee Details
                  </h4>
                </div>
                <div className="bg-gray-50 rounded-2xl overflow-hidden">
                  <div className="overflow-x-auto">
                    <table className="w-full">
                      <thead className="bg-blue">
                        <tr>
                          <th className="px-6 py-4 text-left font-semibold text-sm text-white">
                            Field
                          </th>
                          <th className="px-6 py-4 text-left font-semibold text-sm text-white">
                            Value
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {filterEmptyFields(receiverDetails).map(
                          ([key, value], index) => (
                            <tr
                              key={key}
                              className={`${
                                index % 2 === 0 ? "bg-white" : "bg-gray-50"
                              } transition-colors`}
                            >
                              <td className="px-6 py-4 font-medium text-grey capitalize">
                                {key.replace(/_/g, " ")}
                              </td>
                              <td className="px-6 py-4 text-grey">{value}</td>
                            </tr>
                          )
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              {/* Shipment Details */}
              <div className="space-y-4">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-8 h-8 bg-blue/10 rounded-xl flex items-center justify-center">
                    <i className="fas fa-shipping-fast text-blue text-sm"></i>
                  </div>
                  <h4 className="text-blue text-xl font-bold">
                    Shipment Details
                  </h4>
                </div>
                <div className="bg-gray-50 rounded-2xl overflow-hidden">
                  <div className="overflow-x-auto">
                    <table className="w-full">
                      <thead className="bg-blue">
                        <tr>
                          <th className="px-6 py-4 text-left font-semibold text-sm text-white">
                            Field
                          </th>
                          <th className="px-6 py-4 text-left font-semibold text-sm text-white">
                            Value
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {filterEmptyFields(shipmentDetails).map(
                          ([key, value], index) => (
                            <tr
                              key={key}
                              className={`${
                                index % 2 === 0 ? "bg-white" : "bg-gray-50"
                              } transition-colors`}
                            >
                              <td className="px-6 py-4 font-medium text-grey capitalize">
                                {key.replace(/_/g, " ")}
                              </td>
                              <td className="px-6 py-4 text-grey">
                                {Array.isArray(value)
                                  ? value.join(", ")
                                  : value}
                              </td>
                            </tr>
                          )
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    // GENERIC FORM FIELDS FOR OTHER STEPS
    const currentDetails =
      currentStep === 1
        ? shipperDetails
        : currentStep === 2
        ? receiverDetails
        : shipmentDetails;
    const currentErrors =
      currentStep === 1
        ? errors.shipperDetails
        : currentStep === 2
        ? errors.receiverDetails
        : errors.shipmentDetails;

    const getSectionTitle = () => {
      switch (currentStep) {
        case 1:
          return "Shipper Information";
        case 2:
          return "Consignee Information";
        default:
          return "Shipment Information";
      }
    };

    const getSectionIcon = () => {
      switch (currentStep) {
        case 1:
          return "fa-user";
        case 2:
          return "fa-user-tag";
        default:
          return "fa-shipping-fast";
      }
    };

    const getSectionDescription = () => {
      switch (currentStep) {
        case 1:
          return "Enter the sender's contact and address information";
        case 2:
          return "Enter the receiver's contact and address information";
        default:
          return "Enter the shipment details and specifications";
      }
    };

    return (
      <div className="w-full max-w-6xl mx-auto">
        <div className="rounded-3xl shadow-xl border border-white/20 overflow-hidden">
          <div className="bg-blue px-8 py-6">
            <div className="flex items-center gap-4">
              <div className="p-3 bg-white/20 rounded-2xl">
                <i
                  className={`fas ${getSectionIcon()} text-white text-2xl`}
                ></i>
              </div>
              <div>
                <h3 className="text-white font-bold text-2xl">
                  {getSectionTitle()}
                </h3>
                <p className="text-white/80">{getSectionDescription()}</p>
              </div>
            </div>
          </div>

          <div className="p-8 bg-white/95 backdrop-blur-sm">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {Object.keys(currentDetails).map((key) => (
                <div key={key} className="space-y-2">
                  <label className="flex items-center gap-2 text-grey font-semibold text-sm">
                    <i className="fas fa-info-circle text-blue text-xs"></i>
                    {key.charAt(0).toUpperCase() +
                      key.slice(1).replace(/_/g, " ")}
                  </label>
                  <input
                    type={
                      key.includes("email")
                        ? "email"
                        : key.includes("phone")
                        ? "tel"
                        : "text"
                    }
                    placeholder={`Enter ${key.replace(/_/g, " ")}`}
                    name={key}
                    className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:border-blue focus:ring-4 focus:ring-blue/10 transition-all duration-300 bg-white hover:border-gray-300 hover:shadow-md"
                    value={currentDetails[key]}
                    onChange={(e) =>
                      handleInputChange(
                        e,
                        currentStep === 1
                          ? setShipperDetails
                          : currentStep === 2
                          ? setReceiverDetails
                          : setShipmentDetails
                      )
                    }
                  />
                  {currentErrors[key] && (
                    <p className="text-red-500 text-sm mt-1 flex items-center gap-1">
                      <i className="fas fa-exclamation-circle text-xs"></i>
                      {currentErrors[key]}
                    </p>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  };

  // const [isSubmitting, setIsSubmitting] = useState(false);

  const submitShipmentToBackend = async () => {
    try {
      const response = await fetch(
        `${API_URL}/api/create-shipment/create-shipment`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            user_id,
            created_by,
            shipperDetails,
            receiverDetails,
            shipmentDetails,
            eta: shipmentDetails.eta, // Ensure these are properly set
            etd: shipmentDetails.etd,
          }),
        }
      );

      const result = await response.json();

      if (response.ok) {
        toast.success("Shipment created successfully!", {
          position: "top-right",
        });
        navigate("/superAdmin/super-dashboard");
        // console.log(result);
        // setSubmissionSuccess(true);
      } else {
        toast.error("Error creating shipment: " + result.message, {
          position: "top-right",
        });
        setSubmissionSuccess(false);
      }
    } catch (error) {
      toast.error("Network error: " + error.message, {
        position: "top-right",
      });
      console.error(error);
      setSubmissionSuccess(false);
    }
  };

  // Add this new resetForm function
  const resetForm = () => {
    // Reset all state to initial values
    setCurrentStep(0);
    setSubmissionSuccess(false);

    setShipperDetails({
      name: "",
      email: "",
      unit: "",
      city: "",
      street: "",
      country: "",
      phone: "",
      building: "",
    });

    setReceiverDetails({
      name: "",
      email: "",
      unit: "",
      city: "",
      street: "",
      country: "",
      phone: "",
      building: "",
    });

    setShipmentDetails({
      description: "",
      type: "",
      shipment_code: "",
      shipment_transport: "",
      instructions: "",
      shipment_mode: "",
      terms: "",
      gross_weight: "",
      eta: "",
      etd: "",
      receivedDate: "",
      remark: "",
      packages: "",
      volume: "",
      containers: [],
      total_weight: "",
      dimensions: [],
      chargeable_weight: "",
      job_order: "",
      commodity: "",
      number_pcs: "",
      cbm: "",
      origin: "",
      destination: "",
      shipment_bound: "",
      flight: "",
      truck_type: "",
      delivery_mode: "",
      corporate_client: "",
      carrier_forwarder: "",
      masterWaybill: "",
      houseWaybill: "",
    });
  };

  // Modified handleSubmit function
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check for duplicate JO before submitting
    if (shipmentDetails.job_order) {
      const joExists = await checkJobOrderExists(
        shipmentDetails.job_order.trim()
      );
      if (joExists) {
        toast.error(
          "This Job Order already exists. Please use a different one.",
          {
            position: "top-right",
          }
        );
        return;
      }
    }

    // Show loading state (optional)
    const loadingToast = toast.loading("Creating shipment...", {
      position: "top-right",
    });

    try {
      const success = await submitShipmentToBackend();

      // Dismiss loading toast
      toast.dismiss(loadingToast);

      if (success) {
        // Success message is already shown in submitShipmentToBackend
        console.log("Shipment created successfully and form reset");
      } else {
        // Error message is already shown in submitShipmentToBackend
        console.log("Failed to create shipment");
      }
    } catch (error) {
      toast.dismiss(loadingToast);
      toast.error("An unexpected error occurred", {
        position: "top-right",
      });
    }
  };

  const renderStepper = () => {
    const progress = (currentStep / (steps.length - 1)) * 100;

    return (
      <div className="w-full max-w-6xl mx-auto mb-8">
        {/* Mobile Version */}
        <div className="block lg:hidden">
          <div className="bg-white/90 backdrop-blur-sm rounded-3xl shadow-xl border border-white/20 p-6">
            <div className="flex items-center justify-between mb-4">
              <div className="relative w-16 h-16">
                <svg
                  className="w-full h-full transform -rotate-90"
                  viewBox="0 0 36 36"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    className="text-gray-200"
                    strokeWidth="3"
                    stroke="currentColor"
                    fill="none"
                    cx="18"
                    cy="18"
                    r="16"
                  />
                  <circle
                    className="text-blue"
                    strokeWidth="3"
                    strokeDasharray={`${progress} ${100 - progress}`}
                    strokeLinecap="round"
                    stroke="currentColor"
                    fill="none"
                    cx="18"
                    cy="18"
                    r="16"
                  />
                </svg>
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="text-blue font-bold text-sm">
                    {currentStep + 1}/{steps.length}
                  </span>
                </div>
              </div>
              <div className="flex-1 ml-4">
                <h3 className="text-blue font-bold text-lg">
                  {steps[currentStep]?.title}
                </h3>
                <p className="text-grey text-sm">
                  {steps[currentStep]?.description}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Desktop Version - Enhanced */}
        <div className="hidden lg:block">
          <div className="bg-white/90 backdrop-blur-sm rounded-3xl shadow-xl border border-white/20 p-8">
            <div className="max-w-4xl mx-auto">
              <div className="flex items-center">
                {steps.map((step, index) => {
                  const isActive = index === currentStep;
                  const isCompleted = index < currentStep;

                  return (
                    <div key={index} className="flex items-center flex-1">
                      {/* Circle */}
                      <div className="flex flex-col items-center">
                        <div
                          className={`w-12 h-12 rounded-full flex items-center justify-center font-bold text-sm transition-all duration-500 border-4
                    ${
                      isCompleted
                        ? "bg-blue text-white border-blue   scale-110"
                        : isActive
                        ? "bg-blue text-white border-blue  scale-125"
                        : "bg-white text-gray-400 border-gray-200 hover:border-gray-300"
                    }`}
                        >
                          {isCompleted ? (
                            <i className="fas fa-check text-sm" />
                          ) : (
                            index + 1
                          )}
                        </div>

                        <div className="text-center max-w-[140px] mt-4">
                          <p
                            className={`text-sm font-semibold mb-1 ${
                              isCompleted || isActive
                                ? "text-blue"
                                : "text-gray-400"
                            }`}
                          >
                            {step.title}
                          </p>
                          <p
                            className={`text-xs ${
                              isActive ? "text-gray-600" : "text-gray-400"
                            }`}
                          >
                            {step.description}
                          </p>
                        </div>

                        <div
                          className={`mt-2 w-2 h-2 rounded-full ${
                            isCompleted
                              ? "bg-green-500"
                              : isActive
                              ? "bg-blue"
                              : "bg-gray-300"
                          }`}
                        />
                      </div>

                      {/* Connector (only between circles) */}
                      {index < steps.length - 1 && (
                        <div className="flex-1 mx-3 relative">
                          {/* background */}
                          <div className="h-1 w-full bg-gray-200 rounded-full" />
                          {/* filled segment: fill for all segments LEFT of currentStep */}
                          <div
                            className={`absolute inset-0 transition-all duration-700 ease-in-out`}
                            style={{
                              width: index < currentStep ? "100%" : "0%",
                            }}
                          >
                            <div className="h-1 w-full bg-blue rounded-full" />
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <section className="flex flex-col justify-center font-poppins bg-gray-100 relative overflow-auto">
      <div className="relative flex flex-col justify-center py-6 px-4">
        {/* Enhanced Header */}
        <div className="text-center mb-8">
          <div className="flex items-center justify-center gap-3 mb-4">
            <h1 className="text-4xl font-bold text-blue">Create Shipment</h1>
          </div>
          <p className="text-grey font-medium text-lg">
            Create and manage your shipments with our streamlined process
          </p>
        </div>

        {/* Stepper */}
        {renderStepper()}

        {/* Form */}
        <form onSubmit={handleSubmit} className="space-y-8">
          {renderFormFields()}

          {/* Navigation Buttons */}
          <div className="w-full max-w-6xl mx-auto">
            <div className="bg-white/90 backdrop-blur-sm rounded-3xl shadow-xl border border-white/20 p-6">
              <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
                {currentStep > 0 ? (
                  <button
                    type="button"
                    onClick={handleBack}
                    className="w-full sm:w-auto px-8 py-3 bg-gray-200 hover:bg-gray-300 text-grey font-medium rounded-2xl transition-all duration-300 transform hover:scale-105 shadow-md hover:shadow-lg flex items-center justify-center gap-2"
                  >
                    <i className="fas fa-arrow-left text-sm"></i>
                    Back
                  </button>
                ) : (
                  <div></div>
                )}

                <div className="flex items-center gap-2 text-grey text-sm">
                  <span>
                    Step {currentStep + 1} of {steps.length}
                  </span>
                </div>

                {currentStep > 0 && currentStep < 4 && (
                  <button
                    type="button"
                    onClick={handleNext}
                    className="w-full sm:w-auto px-8 py-3 bg-blue hover:bg-blue/90 text-white font-medium rounded-2xl transition-all duration-300 transform hover:scale-105 shadow-md hover:shadow-lg flex items-center justify-center gap-2"
                  >
                    Next Step
                    <i className="fas fa-arrow-right text-sm"></i>
                  </button>
                )}

                {currentStep === 4 && (
                  <button
                    type="submit"
                    className="w-full sm:w-auto px-8 py-3 bg-gradient-to-r from-blue to-blue/80 hover:from-blue/90 hover:to-blue text-white font-medium rounded-2xl transition-all duration-300 transform hover:scale-105 shadow-md hover:shadow-lg flex items-center justify-center gap-2"
                  >
                    <i className="fas fa-paper-plane text-sm"></i>
                    Submit Shipment
                  </button>
                )}
              </div>
            </div>
          </div>
        </form>
      </div>
    </section>
  );
};

export default CreateShipment;
